<section class="h-full">

  <div class="h-full relative">

    <!-- BarCode container -->
    <div class="videoContainer h-full">
      <zxing-scanner class="h-full" style="background-color: black" [(device)]="selectedCamera"
        [formats]="allowedFormats" [autofocusEnabled]="true" (scanSuccess)="scanSuccessHandler($event)"
        (camerasFound)="camerasFoundHandler($event)">
      </zxing-scanner>
    </div>

    <!-- Setting icon container -->
    <div class="settingsContainer absolute" style="bottom: 0.5rem; right: 0.5rem;">
      <i class="pi pi-cog cursor-pointer" style="font-size: 1.3rem; color: white;" (click)="showDialog()"></i>
    </div>
  </div>

  <p>{{selectedCamera}}</p>
  <p>{{camerasFounded}}</p>

  <div *ngIf="barcodeMessage" class="mt-3 flex flex-column">
    <p>Link: <a [href]="barcodeMessage">{{barcodeMessage}}</a></p>
  </div>

  <!-- Dialog container -->
  <p-dialog class="codeTypesDialog" header="Impostazioni scanner" [(visible)]="formatsModal" [modal]="true"
    [style]="{width: '40vw'}" [draggable]="false" [resizable]="false" [closable]="false">

    <div class="w-full" style="position: sticky; top: 0; z-index: 1; background-color: white;">
      <p *ngIf="requiredCode" style="color: brown;">Selezionare almeno un codice dalla
        lista</p>
    </div>

    <div class="grid">
      <div class="col-12 sm:col-6 md:col-6 lg:col-6">
        <h3 class="mb-2">Camere:</h3>
        <div class="flex flex-column">
          <label>Camera in uso</label>
          <p-dropdown class="mt-2" [options]="camerasFounded" [(ngModel)]="selectedCamera" optionLabel="label">
          </p-dropdown>
        </div>
      </div>

      <div class="col-12 sm:col-6 md:col-6 lg:col-6">
        <h3 class="mb-3">Codifiche disponibili:</h3>

        <div *ngFor="let barcodeType of barcodeTypes" class="field-checkbox">
          <p-checkbox name="codes" [value]="barcodeType" [(ngModel)]="selectedBarcodeTypes"
            [inputId]="''+barcodeType.id"></p-checkbox>
          <label>{{barcodeType.descrizione}}</label>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button pButton pRipple type="button" label="Annulla" class="p-button-outlined p-button-danger"
        (click)="cancelCodes()"></button>
      <button pButton pRipple type="button" label="Conferma" (click)="saveCodes()"></button>
    </ng-template>
  </p-dialog>

</section>
